var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 5.5098687,12.029869 a 1.79,1.79 0 0 1 0.51,-1.28 L 16.399869,0.38986871 a 1.25,1.25 0 0 1 1.76,1.76999999 l -9.8600003,9.8700003 9.8600003,9.86 a 1.25,1.25 0 0 1 -1.76,1.77 l -10.3800003,-10.35 a 1.81,1.81 0 0 1 -0.51,-1.28 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9a509f785efa37b7d6b9865b46da75a5.svg";
export { ForwardRef as ReactComponent };